import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-change',
  templateUrl: './change.component.html',
  styleUrls: ['./change.component.css']
})
export class ChangeComponent implements OnInit {
  ChangeForm: FormGroup;
  progress = false;
  MensajeError = false;
  MensajeSucces = false;
  btnEnviar = false;
  validacionDisponible = false;
  idcontact = '';

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private service: AccountService) {
    this.ChangeForm = fb.group({
      Clave: ['', [Validators.required, Validators.maxLength(16), Validators.minLength(3), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$.$-$,$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,16}$/)]],
      Clave2: ['', [Validators.required, Validators.maxLength(16), Validators.minLength(3)]]
    },
      {
        validators: [this.ClavesIguales('Clave', 'Clave2')]
      });
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  ngOnInit(): void {
    console.log('asdasdasd', this.route.params)
    this.route.params.subscribe(
      param => {
        this.service.Validar(param.id).subscribe(
          (data: any) => {
            if (data.Error == false) {
              this.idcontact = param.id;
              this.validacionDisponible = true;
            } else {
              this.btnEnviar = true;
              this.MensajeError = true;
            }
          },
          (error) => {
            this.btnEnviar = true;
            this.MensajeError = true;
          },
          () => { }
        );
        console.log('asdasdasda asd asd asd',param.id)

      },
      err => console.log(`[Error!] API ' :${err}`),
      () => console.log(`[Termino] API -  GetbyId`)


    );
  }
  Solicitud() {
    this.validateAllFormFields(this.ChangeForm);
    if (this.ChangeForm.valid && this.validacionDisponible) {
      this.progress = true;
      this.service.Change(this.idcontact, this.ChangeForm.controls["Clave"].value).subscribe(
        (data: any) => {
          if (data.Error == false) {
            this.ChangeForm.reset();
            this.MensajeSucces = true;
            setTimeout(() => {
              this.MensajeSucces = false;
            }, 1000);
          }
        },
        (err) => {
          this.MensajeError = true;
          setTimeout(() => {
            this.MensajeError = false;
          }, 1000);
        },
        () => {
          this.progress = false;
        }
      );
    }
  }
  ClavesIguales(pass1Name: string, pass2Name: string) {
    return (formGroup: FormGroup) => {

      const pass1Control = formGroup.get(pass1Name);
      const pass2Control = formGroup.get(pass2Name);

      if (pass1Control.value === pass2Control.value) {
        pass2Control.setErrors(null)
      } else {
        pass2Control.setErrors({ noEsIgual: true })
      }


    }
  }
}
